import { operatorClient } from 'domain/HttpClients';

export const fetch = (cursor) => operatorClient
  .Get('/api/shipments')
  .withParams({
    status: 'UNASSIGNED',
    domain: SYSTEM_DOMAIN,
    cursor,
  })
  .send();

export const assign = (shipments) => operatorClient
  .Post('/api/shipments/assign')
  .withData(shipments)
  .send();
